(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  } else if (url.searchParams.has('page')) {
    // Manufacturer pages: the product grid is paginated and sits far down a long
    // profile page, so a page-2 link would otherwise land the buyer back at the
    // hero. Open paged views on the products heading instead. The #products
    // anchor only exists on manufacturer pages, so category collections and
    // search keep their normal behaviour.
    const jumpToProducts = () => {
      const heading = document.getElementById('products');
      if (heading && document.querySelector('.product-grid-container--member')) {
        heading.scrollIntoView({ behavior: 'instant' });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', jumpToProducts, { once: true });
    } else {
      jumpToProducts();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
